<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline mb-3">
          <span class="font-weight-bold d-flex align-center">
            <v-icon v-if="!$store.state.disable_table" class="mr-3 black--text" @click="goBack()">
              mdi-arrow-left
            </v-icon>
            Back
          </span>
        </h2>
      </v-col>
    </v-row>

    <v-row class="__list-product">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div v-scroll="onScrollProduct">
          <div v-for="(item, idx) in productGroup" :key="idx + '-item-product'" class="__item-product">
            <list-product
              v-if="item.items.length !== 0"
              :products="item.items"
              :title="item.product_group_name"
              :showdata="showDetailProduct"
              :view-image="showImage"
            />
          </div>
        </div>
      </v-col>

      <v-bottom-sheet v-model="sheetDetail" persistent :content-class="'product__detail'">
        <v-sheet style="height: 100%">
          <v-form id="addCartItems" @submit.prevent="addCartProduct()">
            <v-container fluid>
              <v-row class="ma-0">
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                  <v-btn text icon color="red lighten-2" @click="closeShowDetail()">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                  <v-list class="list-product py-0">
                    <v-list-item>
                      <v-list-item-avatar class="list-img-square image-detail" @click="showImage(photo_product)">
                        <v-img :src="photo_product" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="productDetails.name" />
                        <v-list-item-subtitle v-if="(Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 1) || Number(productDetails.pos_sell_price_dynamic) === 0" v-mask-money="formProduct.sell_price" class="font-weight-bold title subtitle-2" />
                      </v-list-item-content>
                    </v-list-item>

                    <div v-if="Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 0" class="d-flex px-7 py-4 section-dynamic-order">
                      <div class="section-dynamic-order-avatar">
                        <v-img src="@/assets/images/order_cashier.png" :aspect-ratio="1/1" width="80" />
                      </div>
                      <div class="section-dynamic-order-content">
                        <div class="section-dynamic-order-content-title">
                          Pesan langsung di kasir
                        </div>
                        <div class="section-dynamic-order-content-subtitle">
                          Menu ini hanya dapat dipesan di kasir.
                        </div>
                      </div>
                    </div>

                    <template v-if="productDetails.description">
                      <v-divider />
                      <v-list-item class="__detail-description" @click="more_description = !more_description">
                        <v-list-item-content>
                          <v-list-item-subtitle :class="['animate-fade', { 'more-description-detail': more_description }]">
                            <div v-html="html_description" />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider />
                    </template>
                  </v-list>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0 margin-bottom-addtocart">
                  <v-row v-if="productDetails.items && productDetails.items.length !== 0 && !$store.state.selected_outlet.hide_combo_item" class="ma-0">
                    <v-col cols="12" class="px-0">
                      <h4 class="title">
                        <span class="font-weight-bold grey--text">Detail item</span>
                      </h4>
                      <template v-for="(child, idx) in productDetails.items">
                        <template v-if="child.children.length !== 0">
                          <v-select :key="idx + '-item-variant-id'" v-model="combo_items.id[idx]" :items="commodity[idx]" item-text="name" item-value="id" hide-details solo class="mb-2" @change="selectComboItem(idx)">
                            <template v-slot:selection="{ item }">
                              {{ parseFloat(item.qty) + 'x' }} {{ item.name }}
                            </template>
                          </v-select>
                        </template>
                        <template v-else>
                          <input :key="idx + '-item-id'" type="hidden" :value="combo_items.id[idx]">
                          <v-text-field :key="idx + '-item-variant-id'" :label="child.qty + 'x ' + child.product_name + (child.product_variant_name !== null ? ' - ' + child.product_variant_name : '')" disabled hide-details solo class="mb-2" />
                        </template>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row v-if="productDetails.variants && productDetails.variants.length !== 0" class="ma-0">
                    <v-col cols="12" class="px-0">
                      <h4 class="title mb-4">
                        <span class="font-weight-bold grey--text">Variants</span>
                      </h4>
                      <div v-for="(variant, idx) in productDetails.variant_tag" :key="idx" class="row-variant-tag">
                        <div class="title-variant-tag">
                          {{ variant.label }}
                        </div>
                        <v-radio-group v-model="variant_group[idx]" hide-details class="mt-0 list-variant-tag" @change="selectVariant()">
                          <v-radio v-for="(detail, i) in variant.detail" :key="i" :label="detail" :value="detail" class="list-variant-tag-item" />
                        </v-radio-group>
                        <hr v-if="productDetails.variant_tag.length !== idx + 1" class="my-4 hr-dashed">
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="my-4 divider-row" />
                  <v-row v-if="productDetails.addons && productDetails.addons.length !== 0" class="ma-0">
                    <v-col cols="12" class="px-0 pt-0">
                      <h4 class="title">
                        <span class="font-weight-bold grey--text">Tambahan</span>
                      </h4>
                      <v-list class="list-addons black--text">
                        <template v-for="(item, idx) in productDetails.addons">
                          <v-list-item v-if="item.product_status !== 'X'" :key="idx + '-product-addons'">
                            <v-list-item-content>
                              <v-list-item-title>
                                <span v-if="added_addons[item.id] === true" class="primary--text font-weight-bold">
                                  {{ item.name }}
                                </span>
                                <span v-else class="black--text">
                                  {{ item.name }}
                                </span>
                              </v-list-item-title>
                              <v-list-item-subtitle v-mask-money="item.price" class="font-weight-bold black--text darken-4 text-right" />
                            </v-list-item-content>
                            <v-list-item-action class="__addons-action">
                              <v-btn v-if="added_addons[item.id] === true" text x-small color="primary" class="text-none" @click="removeProductAddons(item.id, item.price, idx)">
                                Remove
                              </v-btn>
                              <v-btn v-else x-small color="primary" class="text-none" @click="addProductAddons(item.id, item.price, item.name, idx)">
                                Add
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" class="px-0 pt-0">
                      <v-text-field v-model="formProduct.note" solo hide-details :label="$t('add_note')" prepend-inner-icon="mdi-file-document-outline" :append-icon="list_note.length !== 0 ? 'mdi-dots-vertical' : ''" @click:append="openDialogNote" @focus="noteOnFocus()" @blur="noteOnBlur()" />
                    </v-col>
                  </v-row>
                </v-col>

                <input type="hidden" :value="formProduct.sell_price">
                <div v-if="(Number(productDetails.pos_sell_price_dynamic) === 1 && Number($store.state.selected_outlet.setting.pos_dynamic_price_can_order) === 1) || Number(productDetails.pos_sell_price_dynamic) === 0" class="sec_add__to__cart">
                  <v-container fluid class="pa-0">
                    <v-row class="ma-0">
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                        <div class="text-center">
                          <div class="d-flex align-center justify-center mb-3">
                            <v-btn color="primary" fab outlined :disabled="disabled" x-small @click="minus()">
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <p class="px-2 my-0">
                              {{ formProduct.qty }}
                            </p>
                            <v-btn color="primary" fab outlined x-small @click="plus()">
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                          <v-btn large color="primary" :disabled="disable_add_cart" width="100%" type="submit" form="addCartItems">
                            Add to cart
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-sheet>
      </v-bottom-sheet>

      <menu-product :class="{ 'hasItemCart': dataInCart.item.length !== 0 }" />
      <item-cart v-if="dataInCart.item.length !== 0" :qtyincart="incart.qty" :price="incart.sub_total" />
    </v-row>

    <v-dialog v-model="dialog.qtyCheck" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          <div v-if="error_from_validate">
            {{ error_string_from_validate }}
          </div>
          <div v-else>
            {{ $t('product_quantity_exceeds_stock', { product_name: unavailable_product }) }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.qtyCheck = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.isOutStock" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('failed_add_to_cart') }}
        </v-card-title>
        <v-card-text>
          {{ $t('product_is_out_stock', { product_name: '' }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.isOutStock = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.variantNotAvailable" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('variant_not_available') }}
        </v-card-title>
        <v-card-text>
          {{ $t('please_select_another_variant') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="dialog.variantNotAvailable = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.view_image" max-width="400">
      <v-card class="card-view-image">
        <v-card-text>
          <v-btn fab x-small color="white" class="btn-close-view-img" @click="closeShowImage">
            <v-icon dark>
              mdi-close
            </v-icon>
          </v-btn>
          <v-img :src="dataproduct_image" :aspect-ratio="1/1" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.list_note" max-width="290">
      <v-card class="card-view-image">
        <v-card-text>
          <template v-if="list_note.length > 0">
            <v-checkbox v-for="(item, idx) in list_note" :key="idx" v-model="listnote[idx]" :label="item" solo hide-details />
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text class="text-none" @click="dialog.list_note = false">
            {{ $t('close') }}
          </v-btn>
          <v-btn color="primary" text class="text-none" @click="saveNote">
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getData as getDataProduct,
  getDetail as getDetailProduct,
  checkMaterial as checkStockMaterial,
  validateMaterial
} from '@/api/product'
import { debounce } from 'debounce'
import listProduct from '@/components/modules/product/ListProduct'
import menuProduct from '@/components/modules/menu/MenuProduct'
import itemCart from '@/components/modules/menu/ItemCart'
export default {
  components: {
    listProduct,
    menuProduct,
    itemCart
  },
  data() {
    return {
      more_description: false,
      html_description: '',
      settingScroll: {
        product: false
      },
      params: {
        page: 1,
        per_page: 20
      },
      disabled: true,
      productGroup: [],
      added_addons: [],
      dataproducts: [],
      productDetails: {},
      sheetDetail: false,
      temporary: {
        products_variant_name: []
      },
      dataCheckout: {
        item: []
      },
      dataInCart: {
        item: []
      },
      list_note: [],
      listnote: [],
      formProduct: {
        product_id: null,
        name: '',
        product_variant_id: null,
        product_variant_name: null,
        note: '',
        addons: [],
        product_combo_id: null,
        product_combo_items: [],
        qty: 0,
        sell_price: 0,
        track_inventory: 0,
        stock_qty: 0,
        hold_qty: 0,
        sub_total: 0,
        non_taxable: 0,
        non_service_charge: 0,
        has_material: 0,
        materials: []
      },
      sub_total: 0,
      dialog: {
        qtyCheck: false,
        view_image: false,
        list_note: false,
        isOutStock: false,
        variantNotAvailable: false
      },
      dataproduct_image: '',
      variant_group: [],
      variant_is_not_available: false,
      photo_product: '',
      disable_add_cart: false,
      temp_cart: {},
      error_from_validate: 0,
      error_string_from_validate: ''
    }
  },
  computed: {
    'incart': function() {
      if (this.dataInCart.item && this.dataInCart.item.length) {
        return this.dataInCart.item.reduce((acc, curr) => {
          return {
            qty: acc.qty + curr.qty,
            sub_total: acc.sub_total + curr.sub_total
          }
        })
      } else {
        return {
          qty: 0,
          sub_total: 0
        }
      }
    },
    loadedProductGroupIds() {
      const ids = []
      if (this.productGroup.length) {
        this.productGroup.map(item => {
          ids.push(item.product_group_id)
        })
        return ids
      }
      return ids
    },
    inCartProductIds() {
      const arr = []
      if (this.dataInCart.item.length) {
        this.dataInCart.item.map(item => {
          if (item.product_id) {
            arr.push(item.product_id)
          }
        })
        return arr
      }
      return arr
    }
  },
  watch: {
    '$route.params.id': function() {
      this.productGroup = []
      this.params.page = 0
      this.loadGroupProduct()
    },
    'formProduct.qty': function(newItem, oldItem) {
      if (newItem <= 1) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    }
  },
  created() {
    this.$store.dispatch('saveSelectedType', 'DINE-IN')
    this.loadGroupProduct()
  },
  mounted() {
    const LOCAL_DATA_CartDineIn = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')
    if (LOCAL_DATA_CartDineIn) {
      this.dataInCart = JSON.parse(LOCAL_DATA_CartDineIn)
    }
  },
  methods: {
    onScrollProduct: debounce(async function() {
      if (this.settingScroll.product === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.loadGroupProduct()
        }
      }
    }, 500),
    async loadGroupProduct() {
      try {
        const params = {
          page: this.params.page++,
          per_page: this.params.per_page,
          search_text: this.$route.params.id,
          search_operator: '=',
          search_column: 'klasifikasi_id'
        }
        const { data } = await getDataProduct(params)
        this.settingScroll.product = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        const data_product = data.data
        await data_product.map(item => {
          let is_available = true
          if (item.has_variant === 0) {
            if (item.track_inventory !== 0) {
              if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                if (Number(item.stock_qty) <= 0) {
                  is_available = false
                } else {
                  is_available = true
                }
              } else {
                is_available = true
              }
            }
          }
          this.$set(item, '__cart_data', { qty: 0, note: '', is_available: is_available })
          this.syncProduct(item, 'product')
          if (!this.loadedProductGroupIds.includes(item.klasifikasi_id)) {
            this.productGroup.push({
              product_group_id: item.klasifikasi_id,
              product_group_name: item.klasifikasi,
              items: data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id)
            })
          } else {
            const productGroup = this.productGroup.filter(group => {
              return item.klasifikasi_id === group.product_group_id
            })
            const index = productGroup[0].items.findIndex((e) => e.id === item.id)
            if (index === -1) {
              productGroup[0].items.push(...data_product.filter(__data => __data.klasifikasi_id === item.klasifikasi_id))
            }
          }
        })
      } catch (e) {
        this.settingScroll.product = true
        this.productGroup = []
        // this.$store.state.show_error = true
        // this.$store.state.error_message = e.string
        // this.$store.state.error_type = e.statusCode
      }
    },
    showImage(item_product) {
      this.dialog.view_image = true
      this.dataproduct_image = item_product
    },
    closeShowImage() {
      this.dialog.view_image = false
      this.dataproduct_image = ''
    },
    async showDetailProduct(item_product) {
      if (Number(item_product.is_out_stock) !== 1 && item_product.__cart_data.is_available !== false && !this.checkStockItem(item_product)) {
        this.resetForm()
        try {
          const { data } = await getDetailProduct(item_product.id)
          this.$store.state.loading_axios = false
          this.productDetails = data.data
          this.photo_product = data.data.photo_md
          if (this.productDetails.description) {
            this.html_description = (this.productDetails.description).replace(/\n/g, '<br />')
          } else {
            this.html_description = ''
          }
          if (data.data.predefined_order_notes) {
            const str = data.data.predefined_order_notes
            this.list_note = str.split(',')
          }
          this.sheetDetail = !this.sheetDetail
          document.querySelector('html').style.overflowY = 'hidden'
          if (this.productDetails.variants.length !== 0) {
            this.variant_group = []
            const is_default = this.productDetails.variants.findIndex((e) => e.is_default === 1)
            if (is_default !== -1) {
              if (this.productDetails.has_material && !this.productDetails.track_inventory) {
                await this.checkStockMaterialObj({
                  product_variant_id: Number(this.productDetails.variants[is_default].id)
                })
              }
              if (this.productDetails.variants[is_default].all_photos.length > 0) {
                this.photo_product = this.productDetails.variants[is_default].photo_md
              }
              if (this.productDetails.track_inventory !== 0) {
                if (this.productDetails.variants[is_default].is_out_stock) {
                  this.variant_is_not_available = true
                } else {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    const stock_incart = this.$stockCart(this.productDetails.variants[is_default].id, '_data_cart_DINE-IN', 'variant')
                    if ((Number(this.productDetails.variants[is_default].stock_qty) - Number(this.productDetails.variants[is_default].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                      this.variant_is_not_available = false
                    } else {
                      this.variant_is_not_available = true
                    }
                  } else {
                    this.variant_is_not_available = false
                  }
                }
              } else {
                this.variant_is_not_available = false
              }
              this.variant_group = this.productDetails.variants[is_default].name.split(',')
              this.formProduct.is_out_stock = this.productDetails.variants[is_default].is_out_stock
              this.formProduct.product_variant_id = this.productDetails.variants[is_default].id
              this.formProduct.product_variant_name = this.productDetails.variants[is_default].name
              this.formProduct.sell_price = parseFloat(this.productDetails.variants[is_default].sell_price_pos)
              this.formProduct.stock_qty = this.productDetails.variants[is_default].stock_qty
              this.formProduct.hold_qty = this.productDetails.variants[is_default].hold_qty
            } else {
              for (var i = 0; i < this.productDetails.variant_tag.length; i++) {
                for (var x = 0; x < this.productDetails.variant_tag[i].detail.length; x++) {
                  this.variant_group[i] = this.productDetails.variant_tag[i].detail[0]
                }
              }
              const variant = this.productDetails.variants.findIndex((e) => e.name === this.variant_group.toString())
              if (variant !== -1) {
                if (this.productDetails.has_material && !this.productDetails.track_inventory) {
                  await this.checkStockMaterialObj({
                    product_variant_id: Number(this.productDetails.variants[variant].id)
                  })
                }
                if (this.productDetails.variants[variant].all_photos.length > 0) {
                  this.photo_product = this.productDetails.variants[variant].photo_md
                }
                if (this.productDetails.track_inventory !== 0) {
                  if (this.productDetails.variants[variant].is_out_stock) {
                    this.variant_is_not_available = true
                  } else {
                    if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                      const stock_incart = this.$stockCart(this.productDetails.variants[variant].id, '_data_cart_DINE-IN', 'variant')
                      if ((Number(this.productDetails.variants[variant].stock_qty) - Number(this.productDetails.variants[variant].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                        this.variant_is_not_available = false
                      } else {
                        this.variant_is_not_available = true
                      }
                    } else {
                      this.variant_is_not_available = false
                    }
                  }
                } else {
                  this.variant_is_not_available = false
                }
                this.formProduct.is_out_stock = this.productDetails.variants[variant].is_out_stock
                this.formProduct.product_variant_id = Number(this.productDetails.variants[variant].id)
                this.formProduct.product_variant_name = this.productDetails.variants[variant].name
                this.formProduct.sell_price = parseFloat(this.productDetails.variants[variant].sell_price_pos)
                this.formProduct.stock_qty = this.productDetails.variants[variant].stock_qty
                this.formProduct.hold_qty = this.productDetails.variants[variant].hold_qty
                this.dialog.variantNotAvailable = false
                this.disable_add_cart = false
              } else {
                this.dialog.variantNotAvailable = true
                this.disable_add_cart = true
              }
            }
          } else {
            if (this.productDetails.has_material && !this.productDetails.track_inventory) {
              await this.checkStockMaterialObj({
                product_id: Number(item_product.id)
              })
            }
            this.formProduct.is_out_stock = this.productDetails.is_out_stock
            this.formProduct.sell_price = parseFloat(this.productDetails.sell_price_pos)
            this.formProduct.stock_qty = this.productDetails.stock_qty
            this.formProduct.hold_qty = this.productDetails.hold_qty
          }
          this.sub_total = this.formProduct.sell_price
          this.formProduct.product_id = item_product.id
          this.formProduct.qty = 1
          this.formProduct.name = this.productDetails.name
          this.formProduct.track_inventory = this.productDetails.track_inventory
          this.formProduct.klasifikasi_id = data.data.klasifikasi_id
          this.formProduct.non_taxable = this.productDetails.non_taxable
          this.formProduct.non_service_charge = this.productDetails.non_service_charge
          this.formProduct.has_material = this.productDetails.has_material
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async syncProduct(item, type) {
      const sourceIds = this.inCartProductIds
      if (sourceIds.includes(item.id)) {
        item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
        item.__cart_data.note = this.noteExistOrNot(item.id, 'product')
      }
    },
    countInCartMultipleSameIds(itemId, type) {
      return this.dataInCart.item.filter(inCartItem => {
        return inCartItem[type + '_id'] === itemId
      }).reduce((acc, curr) => {
        return acc + curr.qty
      }, 0)
    },
    noteExistOrNot(itemId, type) {
      const noteExist = this.dataInCart.item.filter(inCartItem => {
        return inCartItem[type + '_id'] === itemId
      })
      const idx = noteExist.findIndex((e) => e.note !== '')
      if (idx !== -1) {
        return noteExist[idx].note
      }
    },
    async addToCartFinally(itemType) {
      await this.dataInCart.item.push({ ...this.formProduct })
      if (itemType === 'product') {
        const selectedProductGroup = await this.productGroup.filter(item => {
          return item.product_group_id === this.formProduct.klasifikasi_id
        })
        if (selectedProductGroup.length) {
          await selectedProductGroup[0].items.map(async item => {
            if (item.id === this.formProduct.product_id) {
              let is_available = true
              if (item.has_variant === 0) {
                if (item.track_inventory !== 0) {
                  if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                    if (Number(item.stock_qty) === this.countInCartMultipleSameIds(item.id, 'product')) {
                      is_available = false
                    } else {
                      is_available = true
                    }
                  } else {
                    is_available = true
                  }
                }
              }
              item.__cart_data.note = this.noteExistOrNot(item.id, 'product')
              item.__cart_data.qty = this.countInCartMultipleSameIds(item.id, 'product')
              item.__cart_data.is_available = is_available
            }
          })
        }
      }
      await this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
    },
    async addCartProduct() {
      var itemType = 'product'

      this.formProduct.addons = this.formProduct.addons.filter(function(el) {
        return el != null
      })

      if (this.formProduct.addons.length > 0) {
        for (let i = 0; i < this.formProduct.addons.length; i++) {
          this.sub_total = this.sub_total + (this.formProduct.addons[i].product_addon_price * this.formProduct.qty)
        }
      }

      if (this.formProduct.materials.length > 0) {
        for (let i = 0; i < this.formProduct.materials.length; i++) {
          this.formProduct.materials[i].qty_in_cart = Number(this.formProduct.qty) * Number(this.formProduct.materials[i].qty)
        }
      }

      const subTotal = this.sub_total
      this.formProduct.sub_total = subTotal

      const LOCAL_DATA_CartDineIn = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')
      if (LOCAL_DATA_CartDineIn) {
        this.dataInCart = JSON.parse(LOCAL_DATA_CartDineIn)
      }

      if (Number(this.formProduct.product_variant_id)) {
        const variantCart = this.productDetails.variants.find(x => x.id === Number(this.formProduct.product_variant_id))
        if (variantCart.is_out_stock) {
          this.dialog.isOutStock = true
        } else {
          if (this.formProduct.track_inventory === 1) {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              if ((this.$stockCart(this.formProduct.product_variant_id, '_data_cart_DINE-IN', 'variant') + this.formProduct.qty) > (Number(this.formProduct.stock_qty) - Number(this.formProduct.hold_qty))) {
                this.error_from_validate = 0
                this.dialog.qtyCheck = true
              } else {
                await this.addToCartFinally(itemType)
                this.closeShowDetail()
              }
            } else {
              await this.addToCartFinally(itemType)
              this.closeShowDetail()
            }
          } else {
            // if (!this.checkStockMaterials()) {
            //   return false
            // }
            let valid = true
            await this.validateStockMaterial().then((data) => {
              valid = data.valid
              this.error_from_validate = 1
              this.error_string_from_validate = data.message
              this.dialog.qtyCheck = !data.valid
              if (!data.valid) {
                return
              }
            })
            if (valid) {
              await this.addToCartFinally(itemType)
              this.closeShowDetail()
            }
          }
        }
      } else {
        if (this.formProduct.is_out_stock) {
          this.dialog.isOutStock = true
        } else {
          if (this.formProduct.track_inventory === 1) {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              if ((this.$stockCart(this.formProduct.product_id, '_data_cart_DINE-IN') + this.formProduct.qty) > (Number(this.formProduct.stock_qty) - Number(this.formProduct.hold_qty))) {
                this.error_from_validate = 0
                this.dialog.qtyCheck = true
              } else {
                await this.addToCartFinally(itemType)
                this.closeShowDetail()
              }
            } else {
              await this.addToCartFinally(itemType)
              this.closeShowDetail()
            }
          } else {
            // if (!this.checkStockMaterials()) {
            //   return false
            // }
            let valid = true
            await this.validateStockMaterial().then((data) => {
              valid = data.valid
              this.error_from_validate = 1
              this.error_string_from_validate = data.message
              this.dialog.qtyCheck = !data.valid
              if (!data.valid) {
                return
              }
            })
            if (valid) {
              await this.addToCartFinally(itemType)
              this.closeShowDetail()
            }
          }
        }
      }
    },
    async validateStockMaterial() {
      const obj = {
        valid: true,
        message: ''
      }
      try {
        const cart_item = [...this.dataInCart.item]
        const temp_item = { ...this.formProduct }
        this.temp_cart.item = [...cart_item]
        this.temp_cart.item.push(temp_item)
        await validateMaterial(this.temp_cart)
        this.$store.state.loading_axios = false
        return obj
      } catch (e) {
        this.formProduct.product_combo_items = []
        delete this.temp_cart.item
        obj.valid = false
        obj.message = e.string
        return obj
      }
    },
    async selectVariant() {
      const variant = this.productDetails.variants.findIndex((e) => e.name === this.variant_group.toString())
      if (variant !== -1) {
        if (this.productDetails.has_material && !this.productDetails.track_inventory) {
          await this.checkStockMaterialObj({
            product_variant_id: Number(this.productDetails.variants[variant].id)
          })
        }
        if (this.productDetails.variants[variant].all_photos.length > 0) {
          this.photo_product = this.productDetails.variants[variant].photo_md
        } else {
          this.photo_product = this.productDetails.photo_md
        }
        if (this.productDetails.track_inventory !== 0) {
          if (this.productDetails.variants[variant].is_out_stock) {
            this.variant_is_not_available = true
          } else {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              const stock_incart = this.$stockCart(this.productDetails.variants[variant].id, '_data_cart_DINE-IN', 'variant')
              if ((Number(this.productDetails.variants[variant].stock_qty) - Number(this.productDetails.variants[variant].hold_qty)) >= Number(this.formProduct.qty) + stock_incart) {
                this.variant_is_not_available = false
              } else {
                this.variant_is_not_available = true
              }
            } else {
              this.variant_is_not_available = false
            }
          }
        } else {
          this.variant_is_not_available = false
        }
        this.formProduct.is_out_stock = this.productDetails.variants[variant].is_out_stock
        this.formProduct.product_variant_id = Number(this.productDetails.variants[variant].id)
        this.formProduct.product_variant_name = this.productDetails.variants[variant].name
        this.formProduct.sell_price = parseFloat(this.productDetails.variants[variant].sell_price_pos)
        this.formProduct.stock_qty = this.productDetails.variants[variant].stock_qty
        this.formProduct.hold_qty = this.productDetails.variants[variant].hold_qty
        this.formProduct.addons = []
        this.sub_total = this.formProduct.sell_price * this.formProduct.qty
        this.added_addons = []
        this.dialog.variantNotAvailable = false
        this.disable_add_cart = false
      } else {
        this.dialog.variantNotAvailable = true
        this.disable_add_cart = true
      }
    },
    addProductAddons(id, price, name, idx) {
      this.$set(this.added_addons, [id], true)
      const dataAddons = {
        product_addon_id: id,
        product_addon_name: name,
        product_addon_price: Number(price)
      }
      this.formProduct.addons[idx] = dataAddons
    },
    removeProductAddons(id, price, idx) {
      this.$set(this.added_addons, [id], false)
      const arrayAddons = this.formProduct.addons
      arrayAddons.splice(idx, 1)
    },
    plus() {
      this.formProduct.qty = this.formProduct.qty + 1
      this.sub_total = this.sub_total + this.formProduct.sell_price
    },
    minus() {
      this.formProduct.qty = this.formProduct.qty - 1
      this.sub_total = this.sub_total - this.formProduct.sell_price
    },
    goBack() {
      this.$router.push({ name: 'dinein_menu' }).catch(() => {})
    },
    closeShowDetail() {
      this.sheetDetail = false
      document.querySelector('html').style.overflowY = 'scroll'
    },
    resetForm() {
      this.added_addons = []
      this.formProduct.product_id = null
      this.formProduct.product_variant_id = null
      this.formProduct.product_variant_name = null
      this.formProduct.addons = []
      this.formProduct.product_combo_id = null
      this.formProduct.product_combo_items = []
      this.formProduct.qty = 1
      this.formProduct.note = ''
      this.formProduct.has_material = 0
      this.formProduct.materials = []
      this.list_note = []
      this.sub_total = 0
    },
    noteOnFocus() {
      if (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const windowHeightSeventyPercent = parseInt(screen.height * 0.7)
        document.querySelector('.v-dialog.product__detail').style.height = windowHeightSeventyPercent + 'px'
      }
    },
    noteOnBlur() {
      if (/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        document.querySelector('.v-dialog.product__detail').style.height = '100%'
      }
    },
    checkStockItem(item) {
      if (!item.has_variant) {
        if (item.track_inventory) {
          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (Number(item.hold_qty) > Number(item.stock_qty)) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    openDialogNote() {
      this.dialog.list_note = true
      this.listnote = []
    },
    saveNote() {
      for (let i = 0; i < this.list_note.length; i++) {
        if (this.listnote[i]) {
          if (i === 0 && this.formProduct.note === '') {
            this.formProduct.note = this.list_note[i]
          } else {
            this.formProduct.note = this.formProduct.note + ', ' + this.list_note[i]
          }
        }
      }
      this.dialog.list_note = false
    },
    async checkStockMaterialObj(objId) {
      try {
        const { data } = await checkStockMaterial(objId)
        this.$store.state.loading_axios = false
        this.formProduct.materials = data.data.materials
      } catch (e) {
        this.formProduct.materials = []
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    checkStockMaterials() {
      let is_available = true
      if (this.formProduct.materials.length > 0) {
        for (let m = 0; m < this.formProduct.materials.length; m++) {
          if (this.formProduct.materials[m].product_out_stock) {
            this.dialog.isOutStock = true
            is_available = false
            break
          } else {
            if (this.formProduct.materials[m].material_product_variant_id) {
              if (Number(this.formProduct.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.formProduct.materials[m].material_product_variant_id, '_data_cart_DINE-IN', 'variant') + (this.formProduct.qty * Number(this.formProduct.materials[m].qty)) > (Number(this.formProduct.materials[m].product_stock_qty) - Number(this.formProduct.materials[m].product_hold_qty))) {
                    this.dialog.isOutStock = true
                    is_available = false
                    break
                  }
                }
              }
            } else {
              if (Number(this.formProduct.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(this.formProduct.materials[m].material_product_id, '_data_cart_DINE-IN') + (this.formProduct.qty * Number(this.formProduct.materials[m].qty)) > (Number(this.formProduct.materials[m].product_stock_qty) - Number(this.formProduct.materials[m].product_hold_qty))) {
                    this.dialog.isOutStock = true
                    is_available = false
                    break
                  }
                }
              }
            }
          }
        }
      }
      return is_available
    }
  }
}
</script>
